import { render, staticRenderFns } from "./viewPrip.vue?vue&type=template&id=410d08b9&scoped=true"
import script from "./viewPrip.vue?vue&type=script&lang=js"
export * from "./viewPrip.vue?vue&type=script&lang=js"
import style0 from "./viewPrip.vue?vue&type=style&index=0&id=410d08b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d08b9",
  null
  
)

export default component.exports